<template>
    <div class="booker-info">
        <div class="title-section">
            <p class="title">We're missing a few details.</p>
            <p class="subtitle">
                Complete your profile to unlock a smoother, more personalized experience on
                Hedlyner. It only takes a moment!
            </p>
        </div>
        <form class="info-form">
            <div class="address-input-wrapper">
                <label for="address">Where are you based?*</label>
                <input
                    ref="autocomplete"
                    v-model="$v.userData.info.address.$model"
                    class="address-input"
                    type="text"
                    placeholder="city"
                />
                <input type="hidden" v-model="$v.userData.info.lat.$model" />
                <input type="hidden" v-model="$v.userData.info.lon.$model" />
                <p v-if="locationError" class="error-msg">Please select a location.</p>
            </div>
            <div class="phone-input-wrapper">
                <label for="phone_number">Phone number</label>
                <input
                    type="tel"
                    v-model="$v.userData.info.phone_number.$model"
                    v-mask="'(###)###-####'"
                    class="phone-number-input"
                    placeholder="E.g. (415)555-5555"
                />
                <p
                    v-if="
                        $v.userData.info.phone_number.$dirty && !$v.userData.info.phone_number
                    "
                    class="error-msg"
                >
                    Please enter a phone number
                </p>
            </div>
        </form>
    </div>
</template>
<script>
    import { required } from 'vuelidate/lib/validators'

    export default {
        name: 'BookerInfo',
        props: {
            userData: {
                type: Object,
                required: true
            },
            validation: {
                type: Object,
                required: true
            }
        },
        validations: {
            userData: {
                info: {
                    address: { required },
                    lat: { required },
                    lon: { required },
                    phone_number: {
                        correctFormat: function (value) {
                            return !value || /^\([0-9]{3}\)[0-9]{3}-[0-9]{4}$/.test(value)
                        }
                    }
                }
            }
        },
        computed: {
            locationError() {
                return (
                    (this.$v.userData.info.address.$dirty &&
                        !this.$v.userData.info.address.required) ||
                    (this.$v.userData.info.lat.$dirty &&
                        !this.$v.userData.info.lat.required) ||
                    (this.$v.userData.info.lon.$dirty && !this.$v.userData.info.lon.required)
                )
            }
        },
        watch: {
            $v: {
                handler: function (validation) {
                    this.$emit('update:validation', validation)
                },
                immediate: true
            },
            '$v.userData.info.address.$model': function (location) {
                if (location) {
                    this.$v.userData.info.lat.$touch()
                    this.$v.userData.info.lon.$touch()
                }
            }
        },
        mounted() {
            this.$nextTick(() => {
                if (this.$refs?.autocomplete) {
                    this.$emit('autocomplete-loaded', this.$refs.autocomplete)
                }
            })
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .booker-info {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 40px;

        .title-section {
            color: #dedede;
            margin-top: 20px;
            .title {
                @include base-font-24;
                font-weight: 600;
                line-height: 28px;
            }
            .subtitle {
                font-size: 16px;
            }
        }
        .info-form {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            gap: 16px;

            .error-msg {
                color: #ed3c0d;
                font-family: Instrument Sans;
                font-size: 8px;
                font-style: normal;
                font-weight: 600;
                line-height: 130%;
                letter-spacing: 0.14px;
                text-wrap: nowrap;
            }
            label {
                padding: 4px 2px;
                color: #acacac;
                font-family: Instrument Sans;
                font-size: 12px;
                font-style: normal;
                font-weight: 650;
                line-height: 135%;
                letter-spacing: 0.12px;
            }
            input {
                padding: 12px 16px 16px 16px;
                border-radius: 12px;
                border: 1px solid #8b8b8b;
                background: #262626;
                overflow: hidden;
                color: #dedede;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-family: Instrument Sans;
                font-size: 16px;
                font-style: normal;
                font-weight: 550;
                line-height: 125%;
                align-self: stretch;
                width: 100%;
                -moz-appearance: textfield;
                appearance: textfield;
            }
            input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }
            input::placeholder {
                overflow: hidden;
                color: #646464;
                text-overflow: ellipsis;
                @include base-font-16;
                line-height: 125%;
            }
            .address-input-wrapper,
            .phone-input-wrapper {
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
            }
        }
    }
</style>
